import React from 'react';
import img from '../../assets/img/loader.gif';
export default (props) => {
  return (
    <div className="ag-overlay-loading-center" role="presentation">
      <div
        role="presentation"
        style={{
          height: 400,
          width: 100,
          background: `url(${img}) center / contain no-repeat`,
          backgroundSize: '400px 300px',
          margin: '0 auto',
        }}
      ></div>
      <div aria-live="polite" aria-atomic="true">
        {props.loadingMessage}
      </div>
    </div>
  );
};
